'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = user;

var _constants = require('redux/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    change: false,
    error: '',
    preload: false,
    changeWithCode: false,
    errorCode: null
};

function user() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _constants.UserConstants.USER_CHANGE:
            return (0, _extends3.default)({}, state, {
                preload: true,
                change: false,
                error: '',
                errorCode: null
            });
        case _constants.UserConstants.USER_CHANGE_SUCCESS:
            return (0, _extends3.default)({}, state, {
                preload: false,
                change: !!action.result
            });
        case _constants.UserConstants.USER_CHANGE_FAIL:
            return (0, _extends3.default)({}, state, {
                preload: false,
                error: action.error.title,
                change: false,
                errorCode: action.error.code
            });
        case _constants.UserConstants.USER_CHANGE_MAIL:
            return (0, _extends3.default)({}, state, {
                preload: true,
                change: false,
                error: '',
                errorCode: null
            });
        case _constants.UserConstants.USER_CHANGE_MAIL_SUCCESS:
            return (0, _extends3.default)({}, state, {
                preload: false,
                change: !!action.result
            });
        case _constants.UserConstants.USER_CHANGE_MAIL_FAIL:
            return (0, _extends3.default)({}, state, {
                preload: false,
                error: action.error.title,
                change: false,
                errorCode: action.error.code
            });
        case _constants.UserConstants.USER_CHANGE_MAIL_CODE:
            return (0, _extends3.default)({}, state, {
                preload: true,
                changeWithCode: false,
                error: '',
                errorCode: null
            });
        case _constants.UserConstants.USER_CHANGE_MAIL_CODE_SUCCESS:
            return (0, _extends3.default)({}, state, {
                preload: false,
                changeWithCode: !!action.result
            });
        case _constants.UserConstants.USER_CHANGE_MAIL_CODE_FAIL:
            return (0, _extends3.default)({}, state, {
                preload: false,
                error: action.error.title,
                changeWithCode: false,
                errorCode: action.error.code
            });
        case _constants.UserConstants.USER_CHANGE_PHONE:
            return (0, _extends3.default)({}, state, {
                preload: true,
                change: false,
                error: '',
                errorCode: null
            });
        case _constants.UserConstants.USER_CHANGE_PHONE_SUCCESS:
            return (0, _extends3.default)({}, state, {
                preload: false,
                change: !!action.result
            });
        case _constants.UserConstants.USER_CHANGE_PHONE_FAIL:
            return (0, _extends3.default)({}, state, {
                preload: false,
                error: action.error.title,
                change: false,
                errorCode: action.error.code
            });

        case _constants.UserConstants.USER_CHANGE_PHONE_CODE:
            return (0, _extends3.default)({}, state, {
                preload: true,
                changeWithCode: false,
                error: '',
                errorCode: null
            });
        case _constants.UserConstants.USER_CHANGE_PHONE_CODE_SUCCESS:
            return (0, _extends3.default)({}, state, {
                preload: false,
                changeWithCode: !!action.result
            });
        case _constants.UserConstants.USER_CHANGE_PHONE_CODE_FAIL:
            return (0, _extends3.default)({}, state, {
                preload: false,
                error: action.error.title,
                changeWithCode: false,
                errorCode: action.error.code
            });
        case _constants.UserConstants.USER_CONFIRM_MAIL:
            return (0, _extends3.default)({}, state, {
                preload: true,
                change: false,
                error: '',
                errorCode: null
            });
        case _constants.UserConstants.USER_CONFIRM_MAIL_SUCCESS:
            return (0, _extends3.default)({}, state, {
                preload: false,
                change: !!action.result
            });
        case _constants.UserConstants.USER_CONFIRM_MAIL_FAIL:
            return (0, _extends3.default)({}, state, {
                preload: false,
                error: action.error.title,
                change: false,
                errorCode: action.error.code
            });
        case _constants.UserConstants.USER_CONFIRM_MAIL_CODE:
            return (0, _extends3.default)({}, state, {
                preload: true,
                changeWithCode: false,
                error: '',
                errorCode: null
            });
        case _constants.UserConstants.USER_CONFIRM_MAIL_CODE_SUCCESS:
            return (0, _extends3.default)({}, state, {
                preload: false,
                changeWithCode: !!action.result
            });
        case _constants.UserConstants.USER_CONFIRM_MAIL_CODE_FAIL:
            return (0, _extends3.default)({}, state, {
                preload: false,
                error: action.error.title,
                changeWithCode: false,
                errorCode: action.error.code
            });
        case _constants.UserConstants.USER_CONFIRM_PHONE:
            return (0, _extends3.default)({}, state, {
                preload: true,
                change: false,
                error: '',
                errorCode: null
            });
        case _constants.UserConstants.USER_CONFIRM_PHONE_SUCCESS:
            return (0, _extends3.default)({}, state, {
                preload: false,
                change: !!action.result
            });
        case _constants.UserConstants.USER_CONFIRM_PHONE_FAIL:
            return (0, _extends3.default)({}, state, {
                preload: false,
                error: action.error.title,
                change: false,
                errorCode: action.error.code
            });
        case _constants.UserConstants.USER_CONFIRM_PHONE_CODE:
            return (0, _extends3.default)({}, state, {
                preload: true,
                changeWithCode: false,
                error: '',
                errorCode: null
            });
        case _constants.UserConstants.USER_CONFIRM_PHONE_CODE_SUCCESS:
            return (0, _extends3.default)({}, state, {
                preload: false,
                changeWithCode: !!action.result
            });
        case _constants.UserConstants.USER_CONFIRM_PHONE_CODE_FAIL:
            return (0, _extends3.default)({}, state, {
                preload: false,
                error: action.error.title,
                changeWithCode: false,
                errorCode: action.error.code
            });
        case _constants.UserConstants.USER_RESET_ERROR:
            return (0, _extends3.default)({}, state, {
                error: '',
                errorCode: null
            });
        case _constants.UserConstants.USER_CHANGE_PASSWORD:
            return (0, _extends3.default)({}, state, {
                preload: true,
                change: false,
                error: '',
                errorCode: null
            });
        case _constants.UserConstants.USER_CHANGE_PASSWORD_SUCCESS:
            return (0, _extends3.default)({}, state, {
                preload: false,
                change: !!action.result
            });
        case _constants.UserConstants.USER_CHANGE_PASSWORD_FAIL:
            return (0, _extends3.default)({}, state, {
                preload: false,
                error: action.error.title,
                change: false,
                errorCode: action.error.code
            });
        case _constants.UserConstants.USER_CHANGE_INN:
            {
                return (0, _extends3.default)({}, state, {
                    preload: true,
                    change: false,
                    error: '',
                    errorCode: null
                });
            }
        case _constants.UserConstants.USER_CHANGE_INN_SUCCESS:
            {
                return (0, _extends3.default)({}, state, {
                    preload: false,
                    change: !!action.result
                });
            }
        case _constants.UserConstants.USER_CHANGE_INN_FAIL:
            {
                return (0, _extends3.default)({}, state, {
                    preload: false,
                    error: action.error.title,
                    change: false,
                    errorCode: action.error.code
                });
            }
        case _constants.UserConstants.USER_CHANGE_UL_NAME:
            {
                return (0, _extends3.default)({}, state, {
                    preload: true,
                    change: false,
                    error: '',
                    errorCode: null
                });
            }
        case _constants.UserConstants.USER_CHANGE_UL_NAME_SUCCESS:
            {
                return (0, _extends3.default)({}, state, {
                    preload: false,
                    change: !!action.result
                });
            }
        case _constants.UserConstants.USER_CHANGE_UL_NAME_FAIL:
            {
                return (0, _extends3.default)({}, state, {
                    preload: false,
                    error: action.error.title,
                    change: false,
                    errorCode: action.error.code
                });
            }
        case _constants.UserConstants.USER_ADD_ADDRESS:
            {
                return (0, _extends3.default)({}, state, {
                    preload: true,
                    change: false,
                    error: '',
                    errorCode: null
                });
            }
        case _constants.UserConstants.USER_ADD_ADDRESS_SUCCESS:
            {
                return (0, _extends3.default)({}, state, {
                    preload: false,
                    change: !!action.result
                });
            }
        case _constants.UserConstants.USER_ADD_ADDRESS_FAIL:
            {
                return (0, _extends3.default)({}, state, {
                    preload: false,
                    error: action.error.title,
                    change: false,
                    errorCode: action.error.code
                });
            }
        default:
            return state;
    }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/user.js
// module id = 1916
// module chunks = 0